
import Spinner from "./Spinner"
export default {
  exposes: ["hideSpinner", "stopLoadingMorePages", "reset"],
  components: {
    Spinner
  },
  data: () => ({ isFetching: false }),
  mounted() {
    this.observeIfScrolledToBottom()
  },
  beforeDestroy() {
    this.cleanup()
  },
  methods: {
    observeIfScrolledToBottom() {
      const targetEl = this.$refs.bottomElement
      this.observer = new IntersectionObserver(
        entries => {
          if (entries[0].isIntersecting && !this.isFetching) {
            this.isFetching = true
            const isListPopulated = !!this.$slots.default
            if (isListPopulated) {
              this.$emit("bottomReached")
            }
          }
        },
        { threshold: 1 }
      )

      this.observer.observe(targetEl)
    },
    cleanup() {
      if (this.observer) this.observer.disconnect()
    },
    hideSpinner() {
      this.isFetching = false
    },
    stopLoadingMorePages() {
      const targetEl = this.$refs.bottomElement
      this.observer.unobserve(targetEl)
      this.isFetching = false
    },
    reset() {
      this.cleanup()
      this.observeIfScrolledToBottom()
    }
  }
}
